import { render, staticRenderFns } from "./ProductCharacteristics.vue?vue&type=template&id=532fb3e2&scoped=true&"
import script from "./ProductCharacteristics.vue?vue&type=script&lang=js&"
export * from "./ProductCharacteristics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532fb3e2",
  null
  
)

export default component.exports